var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditScore = function SvgCreditScore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "credit_score_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#credit_score_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 8h16V6H4zM2 6q0-.824.587-1.412A1.93 1.93 0 0 1 4 4h16q.824 0 1.413.588Q22 5.175 22 6v6H4v6h3.1q.424 0 .713.288.287.287.287.712 0 .424-.287.712A.97.97 0 0 1 7.1 20H4q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 18zm2 0v12-3.262 1.587zm10.95 13.15 4.925-4.925a.93.93 0 0 1 .712-.287q.413.012.713.312.276.3.287.7a.92.92 0 0 1-.287.7l-5.65 5.65q-.3.3-.7.3a.96.96 0 0 1-.7-.3l-2.85-2.85a.98.98 0 0 1-.287-.687.93.93 0 0 1 .287-.713.93.93 0 0 1 .688-.275q.412 0 .712.275z"
  }))));
};
export default SvgCreditScore;